import { render, staticRenderFns } from "./CustomStatusLink.vue?vue&type=template&id=68738152&scoped=true"
import script from "./CustomStatusLink.vue?vue&type=script&lang=js"
export * from "./CustomStatusLink.vue?vue&type=script&lang=js"
import style0 from "./CustomStatusLink.vue?vue&type=style&index=0&id=68738152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68738152",
  null
  
)

export default component.exports